module.exports = __webpack_public_path__ + "media/images/application/template/logos/first-coach-a167bdc919202172e45da0540cd71a04.png";